import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaShoppingCart } from "@react-icons/all-files/fa/FaShoppingCart";
import { FaStar } from "@react-icons/all-files/fa/FaStar";
import { useDispatch, useSelector } from "react-redux";
import {
    getProductPriceByUniceId,

} from "../../../redux/reduxApi/website/ProductReduxApi";

import {
    getCrossReferenceParts,
    getPartListByIdDataAPi,
} from "../../../redux/reduxApi/website/MakeYearModel";
import { AddToCart } from "./utilsfuncart";
import { cartProductCount } from "../../../redux/reduxApi/website/CartProductCount";
import { FaSpinner } from "@react-icons/all-files/fa/FaSpinner";
import { FaArrowRightLong } from "react-icons/fa6";
import { Minus, Plus } from "lucide-react";
import { getWishlistProducts } from "../../../redux/reduxApi/website/WishlistApi";
import { getDynamicProductList } from "../../../redux/api/admin/ProductApi";
import RelatedProducts from "./RelatedProducts";
const AddtoCart = () => {
    const { id } = useParams();
    // console.log("id", id);
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1);
    const [wishlistPartKeysFromServer, setWishlistPartKeysFromServer] = useState([]);
    const [imageIndex, setImageIndex] = useState(0);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const reviews = useSelector((state) => state.ProductReviews.Reviews.reviews);
    console.log(" this is Reviews ", reviews);
    const UserData = useSelector((state) => state.SingIn.SingIn);
    console.log("this is user data", UserData);

    const [singleProductData, setSingleProductData] = useState({});
console.log("this is single product data", singleProductData);

    const location = useLocation();
    const { uniqueKey, part_no, sellingPrice } = location.state || {};
    console.log("this is location state data", location.state);

    useEffect(() => {
        const fetchSingleProductWithPrice = async () => {
            try {
                // If coming from related products, use the passed state data
                if (location.state && Object.keys(location.state).length > 0) {
                    setSingleProductData({
                        sellingPrice: location.state.sellingPrice || 0,
                        ...location.state,
                    });
                }

                setLoading(true);

                const wishlistRes = await dispatch(getWishlistProducts());

                const prefetch = location.state?.prefetchedPartDetail;
                const usePrefetch =
                    prefetch &&
                    String(prefetch.part_key) === String(id) &&
                    prefetch.part_no != null &&
                    prefetch.aaiabrandid != null;

                let productData;
                let resolvedSellingPrice =
                    location.state?.sellingPrice ??
                    prefetch?.sellingPrice ??
                    0;

                if (usePrefetch) {
                    productData = { ...prefetch };
                } else {
                    productData = await getPartListByIdDataAPi(id);
                    console.log("this is product data in single page", productData);

                    if (!productData) {
                        console.warn("No product data found");
                        return;
                    }

                    const uniqueKeyForPrice = `${productData.part_no}${productData.aaiabrandid}`;
                    const priceRes = await dispatch(
                        getProductPriceByUniceId(uniqueKeyForPrice)
                    );
                    resolvedSellingPrice =
                        priceRes.payload?.data?.productPricingresp?.[0]?.sellingPrice ||
                        location.state?.sellingPrice ||
                        0;
                }

                if (!productData) {
                    console.warn("No product data found");
                    return;
                }

                const uniqueKeyBuilt = `${productData.part_no}${productData.aaiabrandid}`;

                const finalProduct = {
                    ...productData,
                    uniqueKey: uniqueKeyBuilt,
                    sellingPrice: resolvedSellingPrice,
                };

                if (wishlistRes.payload?.data?.wishlist) {
                    setWishlistPartKeysFromServer(
                        wishlistRes.payload.data.wishlist.map((item) => item.partKey)
                    );
                } else {
                    setWishlistPartKeysFromServer([]);
                }

                setSingleProductData(finalProduct);
            } catch (error) {
                console.error("Error fetching single product data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSingleProductWithPrice();
    }, [id, dispatch, location.state]);

    // realted product data
    useEffect(() => {
        const fetchRelatedProductsWithPrice = async () => {
            try {
                // Skip if part_no is not available
                if (!part_no) return;

                // Step 1: Get Related Products
                const response = await getCrossReferenceParts(part_no);
                const relatedData = response.data?.crossReferences;

                console.log("related product data", relatedData);

                if (!relatedData || relatedData.length === 0) {
                    return;
                }

                const partNos = relatedData.map(item => item?.part_no);
                const brandIds = relatedData.map(item => item?.aaiabrandid);

                // Step 2: Get Dynamic Pricing Data
                let mergedProducts = [];
                try {
                    const res = await getDynamicProductList({
                        tableName: "productPricing",
                        operation: "records",
                        filters: {
                            partNo: partNos,
                            aaiBrandId: brandIds
                        }
                    });

                    if (res?.success) {
                        console.log("Dynamic pricing data:", res.data);
                        const pricingData = res.data;

                        mergedProducts = relatedData.map(product => {
                            const matched = pricingData?.find(p => {
                                const brandList = p.aaiBrandId
                                    ?.split(",")
                                    .map(b => b.trim());

                                const brandMatch = brandList?.includes(
                                    product.aaiabrandid?.toString().trim()
                                );

                                const partMatch =
                                    p.partNo?.toString().trim().toLowerCase() ===
                                    product.part_no?.toString().trim().toLowerCase();

                                return partMatch && brandMatch;
                            });

                            return {
                                ...product,
                                part_key: product.part_key || product.part_no,
                                sellingPrice: matched?.sellingPrice ?? 0,
                                uniqueKey: product.part_no + product.aaiabrandid,
                                image: product.image || "/api/placeholder",
                                height: matched?.height ?? "",
                                width: matched?.width ?? "",
                                length: matched?.length ?? "",
                                weight: matched?.weight ?? "",
                                tags: product.tags || [],
                            };
                        });

                        setRelatedProducts(mergedProducts);
                    }
                } catch (err) {
                    console.error("Dynamic product fetch failed:", err);
                    // Set products without pricing if dynamic fetch fails
                    mergedProducts = relatedData.map(product => ({
                        ...product,
                        part_key: product.part_key || product.part_no,
                        sellingPrice: 0,
                        uniqueKey: product.part_no + product.aaiabrandid,
                        image: product.image || "/api/placeholder",
                        height: "",
                        width: "",
                        length: "",
                        weight: "",
                        tags: product.tags || [],
                    }));
                    setRelatedProducts(mergedProducts);
                }

            } catch (error) {
                console.error("error in fetching related products", error);
            }
        };

        fetchRelatedProductsWithPrice();
    }, [dispatch, part_no]);

    const handleIncrease = () => {
        setQuantity(quantity + 1);
    };

    const handleDecrease = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };

    const changeImage = (index) => {
        setImageIndex(index);
    };

    const totalPrice = (
        parseFloat(singleProductData?.sellingPrice) * quantity
    ).toFixed(2);

    const initialVisibleItems = 5;
    const [visibleItems, setVisibleItems] = useState(initialVisibleItems);

    const handleAddToCart = async () => {
        const unique =
            singleProductData?.part_no != null && singleProductData?.aaiabrandid != null
                ? `${singleProductData.part_no}${singleProductData.aaiabrandid}`
                : uniqueKey;
        const productData = {
            ...singleProductData,
            uniqueKey: unique,
        };
        try {
            const response = await AddToCart(productData, quantity);
            console.log("this is response of add to cart", response);
            if (response) {
                dispatch(cartProductCount(localStorage.getItem("customerId")));
            }
        } catch (error) {
            console.error("Error adding product to cart:", error);
        }
    };

    // handel chekout page
    const handleCheckout = () => {
        const userId = UserData?.user_id || UserData?.raw?.user_id;
        if (userId) {
            navigate("/shop/checkouts", {
                state: {
                    cartItems: [
                        {
                            uniqueKey: uniqueKey,
                            part_key: singleProductData.part_key,
                            sellingPrice: singleProductData?.sellingPrice,
                            quantity: quantity,
                            part_type: singleProductData.part_type,
                            price: singleProductData?.sellingPrice,
                            images: singleProductData.images,
                        },
                    ],
                    subtotal: totalPrice,
                    tax: 0,
                    shippingCost: 0,
                    total: totalPrice,
                },
            });
        } else {
            navigate("/login");
            localStorage.setItem("redirect", location.pathname);
        }
    };

    const handleNavigateSinglePage = useCallback((item) => {
        const path = `/shop/single-product/${item.part_key}`;
        const state = {
            uniqueKey: item.part_no + item.aaiabrandid,
            part_no: item.part_no,
            sellingPrice: item?.sellingPrice || 0,
            part_type: item?.part_type,
            part_key: item?.part_key,
            image: item?.image,
            images: item?.images,
            supplier: item?.supplier,
            stock_status: item?.stock_status,
            tags: item?.tags,
            Attributes: item?.Attributes,
            aaiabrandid: item?.aaiabrandid,
        };

        navigate(path, { state });
    }, [navigate]);

    const decodeAndClean = (htmlString) => {
        // Step 1: Decode entities
        const decoded = new DOMParser().parseFromString(htmlString, 'text/html').documentElement.textContent;

        // Step 2: Remove "WARNING:" prefix (case-insensitive) and any tags
        const cleaned = decoded.replace(/<[^>]+>/g, '') // Remove all HTML tags
            .replace(/^\s*WARNING:\s*/i, ''); // Remove WARNING: prefix

        return cleaned;
    };

    return (
        <div className="container mt-[50px]">
            {loading ? (
                <div className="flex justify-center items-center h-96">
                    <FaSpinner className="animate-spin text-4xl text-blue-600" />
                </div>
            ) : (
                <div className="  lg:px-3 px-0 py-[50px] ">
                    <div className="flex lg:flex-row md:flex-row flex-col gap-8 lg:w-11/12 w-full mx-auto">
                        <div className="lg:w-1/2 rounded-lg mb-8">
                            <div className="relative h-96 bg-white  rounded-lg overflow-hidden mb-4 ">
                                {/* {singleProductData.images?.image?.[0]?.id ? (
                                    <img
                                        src={singleProductData.images.image[imageIndex].id}
                                        className="w-full h-full object-contain"
                                        alt={singleProductData.part_no}
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                                        No Image Available
                                    </div>
                                )} */}
                                {(() => {
                                    // Normalize images to array
                                    const images = singleProductData?.images?.image;
                                    const imageArray = !images ? [] : Array.isArray(images) ? images : [images];
                                    const currentImage = imageArray[imageIndex];

                                    return currentImage?.id ? (
                                        <img
                                            src={currentImage.id}
                                            className="w-full h-full object-contain"
                                            alt={singleProductData.part_no}
                                        />
                                    ) : (
                                        <div className="w-full h-full flex items-center justify-center text-gray-400">
                                            No Image Available
                                        </div>
                                    );
                                })()}
                            </div>

                            <div className="flex gap-2 overflow-x-auto pb-2">
                                {/* {singleProductData?.images?.image?.length > 0 &&
                                    singleProductData.images?.image?.map((img, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => changeImage(idx)}
                                            className={`flex-shrink-0 w-[100px] h-[100px] border-2 rounded-lg overflow-hidden ${imageIndex === idx
                                                ? "border-blue-900 border-2"
                                                : "border-gray-200"
                                                }`}
                                        >
                                            <img
                                                src={img.id}
                                                className="w-full h-full object-contain"
                                                alt=""
                                            />
                                        </button>
                                    ))} */}
                                {(() => {
                                    // Get images and normalize to array
                                    const images = singleProductData?.images?.image;
                                    const imageArray = !images ? [] : Array.isArray(images) ? images : [images];

                                    return imageArray.length > 0 && imageArray.map((img, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => changeImage(idx)}
                                            className={`flex-shrink-0 w-[100px] h-[100px] border-2 rounded-lg overflow-hidden ${imageIndex === idx ? "border-blue-900 border-2" : "border-gray-200"
                                                }`}
                                        >
                                            <img
                                                src={img.id}
                                                className="w-full h-full object-contain"
                                                alt=""
                                            />
                                        </button>
                                    ));
                                })()}
                            </div>
                        </div>

                        {/* Product Info */}
                        <div className="lg:w-1/2">
                            <h1 className="text-3xl font-bold text-gray-900 ">
                                {singleProductData.part_type}
                            </h1>

                            <div className="mb-4">
                                <div className="flex items-center gap-2">
                                    <div className="flex items-center">
                                        {[...Array(5)].map((_, i) => (
                                            <FaStar
                                                key={i}
                                                className={`text-lg ${i < 4 ? "text-yellow-400" : "text-gray-300"
                                                    }`}
                                            />
                                        ))}
                                    </div>
                                    <span className="text-gray-500">(24 reviews)</span>
                                </div>
                            </div>
                            <div className="text-3xl font-bold text-red-600 mb-2">
                                ${(Number(sellingPrice) * quantity).toFixed(2)}
                            </div>

                            <div className="mb-4">
                                <h3 className="text-xl font-semibold mb-1">Description</h3>
                                <p className="text-gray-800 leading-relaxed text-lg">
                                    {singleProductData.part_type || "No description available"}
                                </p>
                            </div>

                            <div className="mb-4">
                                <div className="flex items-center gap-2 mb-4">
                                    <div className="flex items-center border rounded-full overflow-hidden py-1">
                                        <button
                                            onClick={handleDecrease}
                                            className="px-[12px] py-1.5 text-gray-700 hover:font-semibold"
                                        >
                                            <Minus size="20px" />
                                        </button>
                                        <span className="w-12 text-center font-semibold text-xl">
                                            {quantity}
                                        </span>
                                        <button
                                            onClick={handleIncrease}
                                            className="px-[12px] py-1.5 text-gray-700 hover:font-semibold"
                                        >
                                            <Plus size="20px" />
                                        </button>
                                    </div>
                                    {/* <span className="text-base text-gray-600 font-semibold tracking-tighter">
                                        {singleProductData.stock_status || "In Stock"}
                                    </span> */}
                                </div>

                                <div className="flex gap-3">
                                    <button
                                        className="bg-blue-900 text-white px-3 py-2 rounded-full hover:bg-blue-800 flex items-center gap-2"
                                        onClick={handleAddToCart}
                                    >
                                        <FaShoppingCart className="text-lg" />
                                        Add to Cart
                                    </button>
                                    {/* <button
                                        className="bg-orange-500 text-white px-3 py-2 rounded-full hover:bg-orange-600"
                                        onClick={handleCheckout}
                                    >
                                        Buy Now
                                    </button> */}
                                </div>
                            </div>

                            <div className="border-t pt-2">
                                <div className="flex items-center gap-2 text-gray-600">
                                    <span className="text-lg text-gray-600 font-semibold">
                                        Supplier:
                                    </span>
                                    <span className="text-base text-gray-700">
                                        {singleProductData.supplier || "N/A"}
                                    </span>
                                </div>
                                <div className="flex items-center gap-2 text-gray-600">
                                    <span className="text-lg text-gray-600 font-semibold">
                                        Part No:
                                    </span>
                                    <span className="text-base  text-gray-700">
                                        {singleProductData.part_no || "N/A"}
                                    </span>
                                </div>
                                <div className="flex items-center gap-2 text-gray-600">
                                    <span className="text-lg text-gray-600 font-semibold">
                                        Part Type:
                                    </span>
                                    <span className="text-base  text-gray-700">
                                        {singleProductData.part_type || "N/A"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Specifications Section */}
                    <div className="my-12 lg:w-11/12 w-full mx-auto">
                        <h1 className="lg:text-4xl font-bold text-blue-900 dark:text-black-700 md:text-lg text-center pb-3">
                            Technical Specifications
                            <span className="ml-2 text-blue-800 text-lg">
                                ({singleProductData.Attributes?.partattributes?.length || 0}{" "}
                                features)
                            </span>
                        </h1>
                        <hr className="heading-seperator border-4 border-orange-600" />

                        <div className="bg-white rounded-2xl  border border-gray-100 overflow-hidden">
                            {/* Table-like structure */}
                            <div className="grid grid-cols-1 md:grid-cols-[minmax(200px,30%)_1fr]">
                                {/* Header */}
                                <div className="hidden md:block bg-gradient-to-r from-blue-50 to-indigo-50 py-2 ps-5 border-b border-gray-200">
                                    <h3 className="text-base font-semibold text-blue-900 uppercase tracking-wide">
                                        Feature Matrix
                                    </h3>
                                </div>
                                <div className="hidden md:block bg-gradient-to-r from-blue-50 to-indigo-50 py-2 ps-5 border-b border-gray-200">
                                    <h3 className="text-base font-semibold text-blue-900 uppercase tracking-wide">
                                        Details
                                    </h3>
                                </div>

                                {/* Specifications */}
                                {Array.isArray(singleProductData.Attributes?.partattributes) &&
                                    singleProductData.Attributes.partattributes
                                        .slice(0, visibleItems)
                                        .map((attr, idx) => (
                                            <React.Fragment key={idx}>
                                                <div
                                                    className={`p-4 ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"
                                                        } 
            border-b border-gray-100 md:border-b-0 md:border-r`}
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-blue-900">
                                                            <FaArrowRightLong size="15px" />
                                                        </span>
                                                        <span className="text-base font-semibold text-gray-700">
                                                            {attr.attribute}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div
                                                    className={`p-4 ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"
                                                        } 
            border-b border-gray-100 group relative`}
                                                >
                                                    <div className="flex items-center justify-between">
                                                        <span
                                                            className={`text-base break-words pr-4 ${attr.value?.toLowerCase().includes("warning")
                                                                ? "text-red-600 font-semibold"
                                                                : "text-gray-600"
                                                                }`}
                                                        >
                                                            {attr.value ? (
                                                                decodeAndClean(attr.value)
                                                            ) : (
                                                                <span className="text-gray-400 italic">Not specified</span>
                                                            )}
                                                        </span>

                                                        <button className="md:hidden text-blue-600 hover:text-blue-800">
                                                            <svg
                                                                className="w-5 h-5"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={2}
                                                                    d="M19 9l-7 7-7-7"
                                                                />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ))}
                            </div>

                            {/* Show More/Less Button */}
                            {(singleProductData.Attributes?.partattributes || []).length >
                                initialVisibleItems && (
                                    <div className="border-t border-gray-100 p-4 text-center">
                                        <button
                                            onClick={() =>
                                                setVisibleItems((prev) =>
                                                    prev === initialVisibleItems
                                                        ? singleProductData.Attributes?.partattributes
                                                            ?.length || 0
                                                        : initialVisibleItems
                                                )
                                            }
                                            className="text-blue-600 hover:text-blue-800 font-medium flex items-center justify-center gap-1 w-full"
                                        >
                                            {visibleItems === initialVisibleItems
                                                ? "Show More Features"
                                                : "Show Fewer Features"}
                                            <svg
                                                className={`w-4 h-4 transition-transform ${visibleItems === initialVisibleItems ? "" : "rotate-180"
                                                    }`}
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                )}

                            {/* Empty State */}
                            {!singleProductData.Attributes?.partattributes?.length && (
                                <div className="p-8 text-center">
                                    <svg
                                        className="mx-auto h-12 w-12 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <h3 className="mt-2 text-sm font-medium text-gray-900">
                                        No specifications available
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500">
                                        Product specifications will be added soon
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {relatedProducts.length > 0 && (
                <RelatedProducts
                    relatedProducts={relatedProducts}
                    initialLikedPartKeys={wishlistPartKeysFromServer}
                    productPageKey={id}
                    onNavigateSinglePage={handleNavigateSinglePage}
                />
            )}
        </div>
    );
};

export default AddtoCart;